<template>
  <div id="inicio" class="banner">
      <div class="textBox">
        <h2>CUENTANOS TU IDEA LA HACEMOS REALIDAD</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam ad
          reiciendis accusantium enim voluptas odit at praesentium sequi.
          Laudantium dicta a suscipit voluptas at ipsa. Excepturi doloremque
          quae asperiores accusantium!
        </p>
        <!-- <a href="#">Ver más</a> -->
      </div>
      <div class="imgBox">
        <img src="../../assets/imgBanner.svg" />
      </div>
      <ul class="sci">
        <li>
          <a href="#"><img src="../../assets/facebook.png" alt=""/></a>
        </li>
        <li>
          <a href="#"><img src="../../assets/twitter.png" alt=""/></a>
        </li>
        <li>
          <a href="#"><img src="../../assets/instagram.png" alt=""/></a>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
    name:"bannerHome"
}
</script>
<style lang="css" scoped>
.banner {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 0 100px;
  background: var(--back);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.banner:before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 400px;
  height: 100%;
  background: var(--accent);
  transform-origin: top;
  transform: skewX(-25deg);
  z-index: 1;
}

.banner .textBox {
  position: relative;
  max-width: 600px;
  z-index: 2;
}

.banner .textBox h2 {
  color: var(--primary);
  font-size: 3em;
}

.banner .textBox p {
  color: var(--textColor);
  font-size: 1.1em;
  margin: 5px 0 25px;
}

.banner .textBox a {
  position: relative;
  display: inline-block;
  background: var(--primary);
  color: var(--textColor);
  padding: 15px 25px;
  text-decoration: none;
  font-size: 1.1em;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
}

.banner .imgBox {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  z-index: 1;
}

.banner .imgBox img {
  position: absolute;
  bottom: 100px;
  width: auto;
  /* z-index: 10000; */
}

.sci {
  position: absolute;
  bottom: 20px;
  letter-spacing: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sci li {
  list-style: none;
}

.sci li a {
  display: inline-block;
  margin-right: 15px;
}

.sci li a img {
  transform: scale(0.5);
  /* filter: invert(1); */
}
@media (max-width: 991px) {
  .banner {
    padding: 150px 50px 0;
    flex-direction: column;
    overflow: hidden;
  }

  .banner:before {
    width: 300px;
    transform: skewX(-25deg) translate(50%);
  }

  .banner .imgBox {
    height: 50vh;
  }

  .banner .imgBox img {
    top: 25px;
    width: 370px;
  }

  .banner .textBox {
    max-width: 100%;
  }

  .sci {
    z-index: 1000;
    left: initial;
    right: 20px;
    flex-direction: column;
  }
}
</style>